import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import ClubCMSRoot from './ClubCMSRoot';
import ClubCMSAction from '../../../actions/club-cms';
import ClubActions from '../../../actions/club';
import participants from '../../../actions/participant';
import {clubSettingsFetchClubCmsConfig} from '../../../selectors/club-settings';

export default connect(
  ({ clubCms: { cmsEditorState, loading }, auth: {user}, clubSettings, club }) => ({
    club_id: user ? user.club.id : null,
    settings: clubSettingsFetchClubCmsConfig(clubSettings),
    cmsEditorState,
    loading,
    club
  }),
  (dispatch) => ({
    updateCmsEditor: (editor) => dispatch(ClubCMSAction.updateCmsEditor(editor)),
    applyClub: (club) => {
      dispatch(ClubCMSAction.applyClub(club))
    },
    loadCMSEditor: (id) => {
      dispatch(participants.fetchList());
      dispatch(ClubActions.fetch(id))
    },
    // save: (editor) => {console.log('saved', editor.toJSON())}
    save: (editor) => dispatch(ClubCMSAction.save(editor)),
    goBack: () => dispatch(push('/clubs'))
  })
)(ClubCMSRoot);



// WEBPACK FOOTER //
// ./src/components/ClubCMS/ClubCMSRoot/index.js